import React from "react"
import PropTypes from "prop-types"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import {
  Grid,
  List,
  ListItem,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@material-ui/core"

import { useTranslation } from "i18n"

// Icons
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import BookIcon from "@material-ui/icons/Book"
import AssessmentIcon from "@material-ui/icons/Assessment"
import ForumIcon from "@material-ui/icons/Forum"

const useStyles = makeStyles(theme => ({
  listRoot: {
    padding: theme.spacing(0),
    width: "100%"
  },
  listItemRoot: {
    padding: theme.spacing(2, 4)
  },
  icon: {
    fontSize: 25,
    marginRight: theme.spacing(2),
    color: "#7d7d7d" // TODO: theme.palette.grey.pearlGrey
  },
  panelDetails: {
    padding: theme.spacing(0),
    backgroundColor: theme.palette.common.white
  },
  panel: {
    // One off use case for custom color
    backgroundColor: "#f3f3f3"
  },
  expansionPanelSummaryRoot: {
    padding: theme.spacing(1, 4)
  },
  capitalize: {
    textTransform: "capitalize"
  }
}))

export default function MilestonePanel({ milestone }) {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Accordion className={classes.panel}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon color="primary" />}
        aria-controls="panel1a-content"
        classes={{
          root: classes.expansionPanelSummaryRoot
        }}
      >
        <Grid container alignItems="center">
          <Grid item xs>
            <Typography variant="h6">{milestone.name}</Typography>
            <Typography
              variant="body1"
              className={classes.capitalize}
              color="textSecondary"
            >
              {Object.keys(milestone.item_count)
                .map(key => `${milestone.item_count[key]} ${key}`)
                .join(" | ")}
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Typography color="primary" variant="body1">
              {t("View Contents")}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className={classes.panelDetails}>
        <List classes={{ root: classes.listRoot }}>
          {milestone.items.map((value, index) => (
            <span key={index}>
              <ListItem classes={{ root: classes.listItemRoot }}>
                {value.content_type === "article" && (
                  <BookIcon className={classes.icon} />
                )}

                {value.content_type === "video" && (
                  <PlayCircleFilledIcon className={classes.icon} />
                )}

                {value.content_type === "discussion" && (
                  <ForumIcon className={classes.icon} />
                )}

                {value.content_type === "assessments" && (
                  <AssessmentIcon className={classes.icon} />
                )}

                <Typography variant="body1">
                  {(value.content_type === "video" ||
                    value.content_type === "article" ||
                    value.content_type === "assessments") &&
                    value.course_item.title}

                  {value.content_type === "discussion" && "Discussion"}
                </Typography>
              </ListItem>
              <Divider />
            </span>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  )
}

MilestonePanel.propTypes = {
  milestone: PropTypes.object
}
